/**
 * Shared layout + brand styling for admin feature tabs (matches Topics / Analytics).
 */
export const adminTabPageTitleSx = {
  fontWeight: 700,
  color: 'text.primary',
  mb: 1,
};

export const adminTabPageSubtitleSx = {
  mb: 3,
};

/** Card shell used across Topics, Analytics, Redemptions, Ambassadors */
export const adminTabCardSx = {
  borderRadius: 3,
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  border: '1px solid rgba(0, 0, 0, 0.05)',
  overflow: 'hidden',
};

export const adminTabCardContentSx = {
  p: 3,
};

/** Primary actions — same gradient as Topics “Add place” / admin shell */
export const adminGradientContainedSx = {
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  textTransform: 'none',
  boxShadow: '0 4px 14px rgba(102, 126, 234, 0.35)',
  '&:hover': {
    background: 'linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%)',
    boxShadow: '0 6px 20px rgba(102, 126, 234, 0.4)',
  },
};

export const adminDialogTitleSx = {
  fontWeight: 700,
  background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.12) 0%, rgba(118, 75, 162, 0.08) 100%)',
  borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
  py: 2,
};
